import React, { useState } from 'react';
import PilotCheckin from './PilotCheckin';
import PilotSuggestion from './PilotSuggestion';

const PilotWelcome = ({ theme, name, palette, onStart }) => {
  const w = theme.welcome || {};
  const starters = w.starters || [];
  const [lead, setLead] = useState(false);   // a suggestion is showing, so it leads
  return (
    <div style={{ maxWidth: '1040px', margin: '0 auto', padding: lead ? '6px 8px 6px' : '18px 8px 8px', textAlign: 'center' }}>
      <h2 style={{ color: palette.textPrimary, fontSize: lead ? 'clamp(28px, 3.2vw, 40px)' : 'clamp(30px, 3.6vw, 44px)', fontWeight: 700, lineHeight: 1.15, margin: '0 0 8px' }}>
        Welcome{name ? `, ${name}` : ''}.
      </h2>
      {w.lead && !lead && (
        <p style={{ color: palette.textPrimary, fontSize: lead ? 'clamp(17px, 1.5vw, 20px)' : 'clamp(18px, 1.6vw, 21px)', lineHeight: 1.5, maxWidth: '900px', margin: '0 auto' }}>{w.lead}</p>
      )}
      {w.note && (
        <p style={{ color: palette.textSecondary, fontSize: '16px', lineHeight: lead ? 1.45 : 1.55, maxWidth: '820px', margin: lead ? '4px auto 0' : '8px auto 0' }}>{w.note}</p>
      )}
      <PilotCheckin context={theme.id} palette={palette} />
      <PilotSuggestion context={theme.id} palette={palette} onStart={onStart} onShown={setLead} />
      {starters.length > 0 && (
        <>
          <div style={{ color: lead ? palette.textSecondary : palette.textPrimary, fontSize: lead ? '17px' : '18px', fontWeight: 600, margin: lead ? '12px 0 8px' : '20px 0 12px' }}>{lead ? 'Or talk about something else' : (w.ask || 'Where would you like to start?')}</div>
          <div style={{ display: 'grid', gridTemplateColumns: lead ? 'repeat(auto-fit, minmax(210px, 1fr))' : 'repeat(auto-fit, minmax(260px, 1fr))', gap: lead ? '10px' : '16px', textAlign: 'left', maxWidth: lead ? '720px' : 'none', margin: lead ? '0 auto' : 0 }}>
            {starters.map((c) => (
              <button key={c.title} type="button" onClick={() => onStart(c.prompt)}
                onMouseEnter={(e) => { e.currentTarget.style.background = (palette.hoverBg || 'rgba(184, 169, 154, 0.18)'); }}
                onMouseLeave={(e) => { e.currentTarget.style.background = palette.cardBg; }}
                style={{ padding: lead ? '12px 16px' : '16px 20px', background: palette.cardBg, border: `1px solid ${palette.border}`, borderLeft: `5px solid ${palette.primary}`, borderRadius: '14px', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', transition: 'background 0.15s' }}>
                <div style={{ color: palette.textPrimary, fontSize: lead ? '18px' : '20px', fontWeight: 700, lineHeight: 1.3 }}>{c.title}</div>
                {!lead && (<div style={{ color: palette.textSecondary, fontSize: '16px', marginTop: '4px', lineHeight: 1.4 }}>{c.sub}</div>)}
              </button>
            ))}
          </div>
        </>
      )}
      <p style={{ color: palette.textSecondary, fontSize: '13px', lineHeight: 1.4, margin: '28px auto 0', letterSpacing: '0.02em' }}>Built by MindStreams Technology</p>
    </div>
  );
};

export default PilotWelcome;
